/**
 * Toolkit JavaScript
 */

// vendor
import Swiper from './components/swiper';

import LazyLoad from './components/lazy-load';

const svg4everybody = require('svg4everybody');
require('objectFitPolyfill');

window.objectFitPolyfill();
svg4everybody();

// polyfills
require('./helpers/polyfills.js');

// General helpers
require('./helpers/_helpers.js');
const debounce = require('./helpers/debounce.js');

// Components
const Viewport = require('./helpers/viewport');
const Shame = require('./shame');
const Video = require('./components/video.js');
const FullscreenVideo = require('./components/video-fullscreen.js');
const FormValidation = require('./components/form-validation.js');
const FormAjax = require('./components/form-ajax.js');
const FloatingLabels = require('./components/floating-labels.js');
const UmbracoFormsLabels = require('./components/umbraco-forms-labels.js');
const Navigation = require('./components/navbar.js');
const Accordion = require('./components/accordion.js');
const Modal = require('./components/modal.js');
const Counter = require('./components/counter.js');
const Infodecrypt = require('./components/infodecrypt.js');
const Gallery = require('./components/gallery.js');
import Slider from './components/slider.js';
const Inview = require('./components/inview');
const File = require('./components/file.js');
const Popup = require('./components/popup.js');
const EqualHeight = require('./components/equal-height');
const AutoSuggest = require('./components/autosuggest');
const Popout = require('./components/popout');
const RequestRFQ = require('./components/request-rfq');
const ScrollTo = require('./components/scrollto');
const EditRFQ = require('./components/edit-rfq');
const Scrollmagic = require('./components/scrollmagic');
const ScrollSnap = require('./components/scroll-snap');

// invoke default js functions
Viewport.init();
Video.init();
FullscreenVideo.init();
FormValidation.init();
FormAjax.init();
FloatingLabels.init();
UmbracoFormsLabels.init();
Navigation.init();
Accordion.init();
Modal.init();
Counter.init();
Infodecrypt.init();
Gallery.init();
Slider.init();
Inview.init();
File.init();
Popup.init();
EqualHeight.init();
AutoSuggest.init();
Popout.init();
RequestRFQ.init();
ScrollTo.init();
EditRFQ.init();
Scrollmagic.init();
ScrollSnap.init();
Swiper.init();

// always do Shame last
Shame.init();

/**
 * Global Event Listeners
 *
 * To reduce many event listeners inside components
 * listening to the same events.
 */
const onResize = () => {
	Viewport.onResize();
	Video.onResize();
	Swiper.onResize();
};
const onResizeDebounced = debounce(onResize, 150);
window.addEventListener('resize', onResizeDebounced);

document.addEventListener('click', ev => {
	if (!ev.target.closest('.nav-desktop')) Navigation.toggleLookingGlass(false);
});

document.addEventListener('keyup', ev => {
	// Escape
	if (ev.key === 'Escape') {
		Navigation.toggleLookingGlass(false);
	}
});

document.addEventListener('DOMContentLoaded', () => {
	LazyLoad.init();
});
